import React, { useState, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";

const OTPInput = ({otp, setOtp}) => {
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const { value } = e.target;

    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input
      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      // Clear current input
      if (otp[index] !== "") {
        newOtp[index] = "";
      } else if (index > 0) {
        // Move to the previous input if current is empty
        newOtp[index - 1] = "";
        inputRefs.current[index - 1].focus();
      }

      setOtp(newOtp);
    }
  };

  return (
    <div className="d-flex justify-content-center flex-column">
      <Row>
        {otp.map((digit, index) => (
          <Col className="otp-input" key={index} xs="auto">
            <Form.Control
              type="text"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              maxLength={1}
              ref={(el) => (inputRefs.current[index] = el)}
              className="text-center border rounded"
              style={{
                width: "3rem",
                height: "3rem",
                fontSize: "1.5rem",
                margin: "0.5rem",
                backgroundColor: "white",
              }}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default OTPInput;
